module.exports = __webpack_public_path__ + "static/media/infinity-solid-full.9647e9a3.svg";